import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { logout } from '../../../common/modules/auth';

class LogoutContainer extends Component {
  componentWillMount() {
    this.props.logout();
  }

  render() {
    return null;
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
  };
};

LogoutContainer.propTypes = {
  logout: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(LogoutContainer);



// WEBPACK FOOTER //
// ./src/routes/Logout/containers/LogoutContainer.js